import ApiError from '../../models/api-error';

export default class Login extends ApiError {
    email: string;
    password: string;
    isRememberMe: boolean;

    constructor(login: string, password: string) {
        super();
        this.email = login;
        this.password = password;
    }
}




// WEBPACK FOOTER //
// ./src/app/login/models/login.ts